/**
 * Created by lycheng on 2017/11/23.
 * 产品服务页相关接口
 */
import 'babel-polyfill'
import { config } from 'config'

/**
 * 判断package需要进行的认证状态
 * @param packageId
 * @param async
 * @returns {Promise}
 */
function getPackageCerType ({packageId}, {async = true}) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/package/getPackageCerType',
      type: 'get',
      dataType: 'json',
      async: async,
      cache: false,
      data: {
        packageId
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

export {
  getPackageCerType
}



// WEBPACK FOOTER //
// ./src/js/api/package.js